import React, { useState } from "react";
import { Form, Input, message } from "antd";
import TextArea from "antd/es/input/TextArea";
import { useDispatch, useSelector } from "react-redux";
import { ReloadTrue, hideLoading, showLoading } from "../redux/rootSlice";
import axios from "axios";

const AdminHeroSection = () => {

    const { portfolioData } = useSelector((state) => state.root);
    const { heroSection } = portfolioData || {}; // Use optional chaining
    const [selectItemEdit, setselectItemEdit] = useState(null);
    const dispatch = useDispatch();
    const [form] = Form.useForm();

    const onFinish = async (values) => {
        try {

            dispatch(showLoading());
            const response = await axios.post(
                `https://backendz182.up.railway.app/api/portfolio/update-heroSEction/${selectItemEdit?._id}`,
                values
            );

            dispatch(hideLoading());

            if (response.data.success) {
                dispatch(ReloadTrue());
                message.success(response.data.message);

            } else {
                message.error(response.data.message);
            }
        } catch (error) {
            console.error("Error:", error);
            message.error("An error occurred. Please try again.");
        }
    };

    return (
        <>
            <div>

                <div className="px-5 py-2 flex flex-col gap-3">
                    <p className="text-xl font-bold">Add HeroSection Details</p>
                    <Form
                        onFinish={onFinish}
                        layout="vertical"
                        form={form}
                        initialValues={heroSection}
                        style={{ width: 550 }}
                        variant="filled">
                        <Form.Item label="Full Name" name="name" className="font-semibold">
                            <Input className=" h-[40px]" required placeholder="Enter your name" />
                        </Form.Item>
                        <Form.Item
                            label="Caption"
                            name="caption"
                            className="font-semibold">
                            <Input className=" h-[40px]" required placeholder="Enter Caption" />
                        </Form.Item>
                        <Form.Item
                            label="Description"
                            name="desc"
                            className="font-semibold">
                            <TextArea
                                className=" h-[100px]"
                                rows="5"
                                required
                                placeholder="Enter Description"
                            />
                        </Form.Item>
                        <Form.Item label="Image URL" name="img" className="font-semibold">
                            <Input className=" h-[40px]" placeholder="Enter Image URL" />
                        </Form.Item>
                        <Form.Item
                            label="Hire URL"
                            name="hireMeBtn"
                            className="font-semibold">
                            <Input className=" h-[40px]" placeholder="Enter Hire URL" />
                        </Form.Item>
                        <Form.Item
                            label="Resume URL"
                            name="resumeBtn"
                            className="font-semibold">
                            <Input className=" h-[40px]" placeholder="Enter Resume/CV URL" />
                        </Form.Item>
                        <Form.Item>
                            <button
                                className="h-[40px] float-right bg-transparent hover:bg-primary text-primary-700 font-semibold hover:text-white py-2 px-4 border border-primary hover:border-transparent rounded"
                                type="submit"
                                onClick={() => {
                                    setselectItemEdit(heroSection)
                                }}
                            >
                                Update
                            </button>
                        </Form.Item>
                    </Form>
                </div>
            </div>
        </>
    );
};

export default AdminHeroSection;
